import {Component, OnInit} from '@angular/core';
import {ModalController, NavController} from '@ionic/angular';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.page.html',
  styleUrls: ['./menu.page.scss'],
})
export class MenuPage implements OnInit {

  constructor(public modalController: ModalController, private nav: NavController) {
  }

  ngOnInit() {
  }

  close() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      'dismissed': true
    });
  }


  gotoPage() {
    this.nav.navigateForward('/account');

    this.modalController.dismiss({
      'dismissed': true,
      'animation': true
    });
  }

}
